import { render, staticRenderFns } from "./Infoitem.vue?vue&type=template&id=0fcf68d0&"
import script from "./Infoitem.vue?vue&type=script&lang=js&"
export * from "./Infoitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports